import { render, staticRenderFns } from "./claimRiskReviewPage.vue?vue&type=template&id=1188c2b2&scoped=true"
import script from "./claimRiskReviewPage.vue?vue&type=script&lang=js"
export * from "./claimRiskReviewPage.vue?vue&type=script&lang=js"
import style0 from "./claimRiskReviewPage.vue?vue&type=style&index=0&id=1188c2b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1188c2b2",
  null
  
)

export default component.exports